import { DynamicSetting, DynamicSettingValueType } from '@k3/core'

export const additionalDynamicSettings: DynamicSetting[] = [
  {
    key: 'masslinienLabel',
    valueType: DynamicSettingValueType.TRANSLATION,
    label: 'Maßlinien Text',
    defaultValue: 'Maßlinien An/Aus',
  },
  {
    key: 'shadingLabel',
    valueType: DynamicSettingValueType.TRANSLATION,
    label: 'Beschattung Text',
    defaultValue: 'Beschattung An/Aus',
  },
  {
    key: 'nightLabel',
    valueType: DynamicSettingValueType.TRANSLATION,
    label: 'Tag/Nacht Modus Text',
    defaultValue: 'Tag/Nacht Modus',
  },
  {
    key: 'typ',
    valueType: DynamicSettingValueType.TRANSLATION,
    label: 'Typ',
    defaultValue: 'Typ',
  },
]
